import Cookies from 'universal-cookie';

const RegisterInvite = () => {
    const cookies = new Cookies();
    const cookieString = cookies.get('data');
    if(cookieString){
        return ('');
    }

    return (
        <div className="container my-4">
        <h2 className="mb-4 text-center">
            Vuoi caricare la tua elaborazione o fare domande alla community?
        </h2>
        <div className="row justify-content-center">
            <a href="/register" className="btn btn-primary btn-lg px-5">
            👉 Crea un account in 1 minuto
            </a>
        </div>
        </div>
    );
};

export default RegisterInvite;
